import React from 'react';
import HeaderSkeleton from './HeaderSkeleton';
import CampaignHeaderSkeleton from './CampaignHeaderSkeleton';
import ArticlesListSkeleton from './ArticlesListSkeleton';

const MainSkeleton = () => (
  <>
    <HeaderSkeleton />
    <CampaignHeaderSkeleton />
    <ArticlesListSkeleton />
  </>
);

export default MainSkeleton;
